import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { getOrderCssClass } from '../../shared/Site';
import { Button } from 'react-bootstrap';

interface PendingInvoiceListRowProps {
    invoiceId: number;
    brokerFirmName: string;
    orderCount: number;
    invoiceBillingMethod: string;
    status: any;
    site: number;
    tryagain: (invoiceId: number) => void;
}

const PendingInvoiceListRow = (props: PendingInvoiceListRowProps) => {
    return (
        <tr className={getOrderCssClass(props.site)}>
            <td></td>
            <td>{props.brokerFirmName}</td>
            <td></td>
            <td>{Translate(props.invoiceBillingMethod)}</td>
            <td>
                {Translate(props.status.displayName)}
                {props.status.value === 3 && (
                    <Button
                        style={{ marginLeft: 10 }}
                        bsSize="small"
                        disabled={false}
                        onClick={() => {
                            props.tryagain(props.invoiceId);
                        }}
                        bsStyle="success"
                    >
                        {Translate('words/try-again')}
                    </Button>
                )}
            </td>
        </tr>
    );
};

export default PendingInvoiceListRow;
